import { useEffect, useState } from "react";
import Card from "../components/Card";
import { generateLink } from "../helpers";

const MovieList = ({apiPath, title}) => {
    const [movies, setMovies] = useState([]);
    // const baseURL = "https://api.themoviedb.org/3/movie/";  
    // const apiKey = `?api_key=${process.env.REACT_APP_MOVIEDB_API}`;
    // const url = baseURL + apiPath + apiKey;

    const url = generateLink(apiPath);

    useEffect(() => {
        async function fetchData(){
            const response = await fetch(url);
            const data = await response.json();
            setMovies(data.results);
        }
        fetchData();
    }, [url]);

    useEffect(() => {
        document.title = `${title} / Cinemate`;
    }, [title]);

    return (
        <>
            <section className="max-w-7xl mx-auto py-7">
                <div className="flex justify-start flex-wrap other:justify-evenly">
                    {movies.map(({id, poster_path, original_title, overview, vote_average, vote_count}) => (
                        <Card key={id} id={id} poster={poster_path} title={original_title} overview={overview} vote_average={vote_average} vote_count={vote_count}/>
                    ))}
                </div>
            </section>
        </>
    );
};

export default MovieList;